export const redirectTo = (url) => {
    window.history.replaceState(null, null, url)
    window.location.href = url
}
